import './styles.scss';

export const SkeletonButtons = () => {
	return (
		<div className="flex flex-wrap gap-4 p-4">
			<button className="w-32 h-10 skeleton"></button>
			<button className="w-32 h-10 skeleton"></button>
			<button className="w-32 h-10 skeleton"></button>
			<button className="w-32 h-10 skeleton"></button>
			<button className="w-32 h-10 skeleton"></button>
			<button className="w-32 h-10 skeleton"></button>
		</div>
	);
};
